import { Form } from "antd";
import { CustomButton } from "@Components/Button";
import FormItem from "@Components/FormItem/FormItem";
import AuthCard from "@Components/AuthCard";
import useResetPasswordContainer from "./useResetPasswordContainer";

const ResetPassword = () => {
  const { form, handleSubmit, handleLogin, isResettingPassword } =
    useResetPasswordContainer();

  return (
    <div className="flex justify-center items-center w-full ">
      <AuthCard
        title="Reset your Password"
        description="Enter your new password and confirm password, make sure it's different from the old password."
      >
        <div className="py-2 sm:py-3 mt-8">
          <Form form={form} onFinish={handleSubmit} layout="vertical">
            <FormItem
              name="password"
              rules={[
                { required: true, message: "Please enter your new password" },
                {
                  min: 8,
                  message: "Password must be at least 8 characters",
                },
              ]}
              inputConfig={{
                label: "New Password",
                isPassword: true,
                placeholder: "Enter password",
              }}
            />

            {/* Confirm Password Field */}
            <FormItem
              name="confirmPassword"
              rules={[
                {
                  required: true,
                  message: "Please confirm your password",
                },
                ({ getFieldValue }) => ({
                  validator(_, value) {
                    if (!value || getFieldValue("password") === value) {
                      return Promise.resolve();
                    }
                    return Promise.reject(new Error("Passwords do not match!"));
                  },
                }),
              ]}
              inputConfig={{
                label: "Confirm Password",
                isPassword: true,
                placeholder: "Re-type new password",
              }}
            />

            {/* Submit Button */}
            <Form.Item className="text-center !mt-9">
              <CustomButton
                title={"Reset Password"}
                shape="round"
                type="primary"
                className="w-full h-11 sm:h-12 font-semibold tracking-wider rounded-[12px]"
                htmlType="submit"
                isLoading={isResettingPassword}
                disabled={isResettingPassword}
              />
            </Form.Item>

            {/* Back to Login Link */}
            <div className="text-center mb-4">
              <p className="!text-sm !font-medium !text-TitleText !font-Nunito">
                Back to{" "}
                <span
                  className="font-semibold !text-primaryGreen cursor-pointer hover:!text-primaryGreen hover:underline transition-all"
                  onClick={handleLogin}
                >
                  login
                </span>
              </p>
            </div>
          </Form>
        </div>
      </AuthCard>
    </div>
  );
};

export default ResetPassword;
